// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file inventory/v1/integration_service.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import { IntegrationService } from "./integration_service_pb";

/**
 * @generated from rpc inventory.v1.IntegrationService.ListAllIntegrations
 */
export const listAllIntegrations = IntegrationService.method.listAllIntegrations;

/**
 * @generated from rpc inventory.v1.IntegrationService.GetIntegration
 */
export const getIntegration = IntegrationService.method.getIntegration;
